export default __webpack_public_path__ + "static/media/full_heart.871f2111.png";